import FilterSm from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/filter';

import BottomSheetChip from '../BottomSheetChip';
import { useMBDContext } from '../common/MBD/useMBDContext';

import FilterLinksItem from './FilterLinksItem';

import type { FilterLinksProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/FilterLinks';

import STYLES from './FilterLinksMobile.module.scss';

type FilterLinksMobileProps = {
  label: string;
} & FilterLinksProps;

const FilterLinksMobile = ({
  filters,
  label,
  title,
}: FilterLinksMobileProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();
  const mbdComponentName = `${rawComponentName}_filter`;

  return (
    <BottomSheetChip
      id="FilterLinkMobile"
      title={title}
      label={label}
      icon={<FilterSm />}
      trackingElementId={`${mbdComponentName}_open_mobile`}
      trackingCommonParams={buildMBDParam(mbdComponentName, {
        filter_name: 'open',
      })}
    >
      <div className={STYLES.FilterLinksMobile__LinksList}>
        {filters.map((filter, categoryIndex) => (
          <FilterLinksItem
            key={filter.name}
            {...filter}
            categoryIndex={categoryIndex}
            trackingVariant="mobile"
          />
        ))}
      </div>
    </BottomSheetChip>
  );
};

export default FilterLinksMobile;
